import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✓ Service Worker registrado com sucesso:', registration.scope);
        // Force a check for a new service worker version on every load so an
        // updated SW (with a bumped cache) replaces the old one quickly.
        registration.update();
        // When a new SW takes control, reload once to pick up fresh assets.
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      })
      .catch((error) => {
        console.log('✗ Falha ao registrar Service Worker:', error);
      });
  });
}
